import React, { FC } from 'react';
import { TextField, TextFieldProps } from '@mui/material';
import { FormikValues } from 'formik';

interface IProps {
  label?: string;
  name: string;
  formik: FormikValues;
  type?: string;
  multiline?: boolean;
  minRows?: number;
  maxRows?: number;
  required?: boolean;
  disabled?: boolean;
}

const getNestedValue = (obj: any, path: string): any => {
  return path.split('.').reduce((current, key) => {
    return current && current[key] !== undefined ? current[key] : undefined;
  }, obj);
};

const Input: FC<IProps & TextFieldProps> = ({
  label,
  name,
  formik,
  type = 'text',
  minRows = 3,
  maxRows,
  multiline = false,
  required = false,
  disabled = false,
  ...rest
}) => {
  const fieldTouched = getNestedValue(formik.touched, name);
  const fieldError = getNestedValue(formik.errors, name);
  const fieldValue = getNestedValue(formik.values, name);

  return (
    <TextField
      helperText={fieldTouched && fieldError}
      error={fieldTouched && !!fieldError}
      variant="outlined"
      id={name}
      name={name}
      type={type}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      value={fieldValue || ''}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      required={required}
      fullWidth
      disabled={disabled}
      placeholder={label}
      inputProps={{
        style: {
          padding: '10px',
        },
      }}
      {...rest}
    />
  );
};

export default Input;
